import { apiClient } from '@/lib/api';
import { createIdempotentMutationHook } from '@/src/hooks/useApiMutation';

export interface RequestProviderAccessVariables {
  provider: 'github';
  requestedLogin: string;
}

export interface UseRequestProviderAccessMutationOptions {
  onSuccess?: () => void;
}

/**
 * Mutation function for requesting provider access.
 */
async function requestProviderAccessMutation(
  variables: RequestProviderAccessVariables,
  { idempotencyKey }: { idempotencyKey: string }
): Promise<unknown> {
  return apiClient.post(
    '/api/provider-accounts/requests',
    {
      provider: variables.provider,
      requestedLogin: variables.requestedLogin,
    },
    undefined,
    undefined,
    { idempotencyKey }
  );
}

/**
 * React Query hook for requesting provider access with automatic idempotency.
 *
 * Uses factory pattern with automatic error handling (toast + Sentry).
 *
 * @example
 * const requestAccess = useRequestProviderAccessMutation({
 *   onSuccess: () => console.log('Access requested')
 * });
 * requestAccess.mutate({
 *   provider: 'github',
 *   requestedLogin: 'octocat'
 * });
 */
export const useRequestProviderAccessMutation = createIdempotentMutationHook<
  unknown,
  RequestProviderAccessVariables
>(requestProviderAccessMutation);
